import { app } from '@/main'

const global = {
  state: {
    isLoading: false,
    langKey: localStorage.getItem('langKey') || 'id'
  },
  mutations: {
    isLoading: (state, payload) => {
      state.isLoading = payload;
    },
    changeLang: (state, payload) => {
      state.langKey = payload;
    }
  },
  actions: {
    setLang({commit}, payload) {
      commit('changeLang', payload)
      localStorage.setItem('langKey', payload)
      setTimeout(() => {
        commit("isLoading", false)
      }, 750);
    }
  }
};

export default global;
